import { useConfigContext } from '../../../contexts/ConfigProvider';
import { Config } from '../../../types/configurations';

const ConfigurationDetails = ({ config }: { config: Config }) => {
  // integration of context hooks here
  const { setConfig, setShowDetailsModal } = useConfigContext();

  // rendering configuration details component here
  return (
    <div>
      <button
        onClick={() => {
          setConfig(config);
          setShowDetailsModal(true);
        }}
        className='font-medium text-base-light-blue hover:opacity-70 active:scale-95 duration-300'
      >
        {config.associate_full_name}
      </button>
    </div>
  );
};

export default ConfigurationDetails;
